import React from "react";
import { useTranslation } from "react-i18next";
import { useRamadan } from "../context/RamadanContext";
import { useDailyContent } from "../utils/dataService";

const DailyTasks: React.FC = () => {
  const { t } = useTranslation();
  const { dayData } = useRamadan();
  const { currentDay } = useRamadan();
  const content = useDailyContent(currentDay);

  // If dayData is not loaded yet
  if (!dayData) {
    return <div className="animate-pulse">Loading...</div>;
  }

  return (
    <div className="relative">
      <div className="bg-[#e7f0dc] rounded-lg p-4">
        <h2 className="text-lg font-bengali font-semibold text-center text-[#4b7a3c] mb-3">
          {t("sections.dailyTask")}
        </h2>

        <div className="bg-[#e7f0dc] p-4 rounded-lg">
          <p className="font-bengali text-center text-[#4b7a3c] font-medium">
            {t(content.taskOfTheDay)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DailyTasks;
